import { render, staticRenderFns } from "./ResourceItemPrefetchedInput.vue?vue&type=template&id=7455bffc&"
import script from "./ResourceItemPrefetchedInput.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemPrefetchedInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports